import { Link } from 'react-router-dom';

const entries = [
  {
    to: '/category/movie',
    icon: 'ri-film-line',
    title: '电影频道',
    desc: '科幻、悬疑、动作、爱情…精选全球佳片',
    count: '共 11 部',
  },
  {
    to: '/category/tv',
    icon: 'ri-tv-2-line',
    title: '电视剧频道',
    desc: '悬疑、古装、都市、战争…追剧不间断',
    count: '共 9 部',
  },
];

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      {entries.map((entry) => (
        <Link
          key={entry.to}
          to={entry.to}
          className="group relative flex items-center gap-5 overflow-hidden rounded-xl border border-background-200 bg-background-50 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
        >
          <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-xl bg-primary-600 text-background-50 transition-colors group-hover:bg-accent-500">
            <i className={`${entry.icon} text-3xl`}></i>
          </span>
          <span className="min-w-0 flex-1">
            <span className="flex items-center gap-2">
              <span className="font-heading text-lg font-bold text-foreground-950">{entry.title}</span>
              <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] font-semibold text-secondary-900">{entry.count}</span>
            </span>
            <span className="mt-1 block truncate text-sm text-foreground-500">{entry.desc}</span>
          </span>
          <i className="ri-arrow-right-line text-xl text-foreground-300 transition-all group-hover:translate-x-1 group-hover:text-accent-500"></i>
        </Link>
      ))}
    </div>
  );
}